module.exports = __webpack_public_path__ + "img/21.e14dbf0a.jpg";